import { useEffect } from 'react'
import { useAppDispatch } from '../../store/hooks'
import { setupMFAForLogin } from '../../store/mfa/mfaSlice'
import { type Token } from '../../common/token'
import { type AuthenticatedUser } from '../../models/User'
import { useMFAComplianceCheck } from './useMFAComplianceCheck'
import { MFA_COMPLIANCE_SETUP_PENDING } from '../../common/constants'

export const useShouldShowMFASetupOverlay = (user: AuthenticatedUser | null, token: Token | null): boolean => {
  const dispatch = useAppDispatch()
  const status = useMFAComplianceCheck(user, token)

  const shouldShow = status === 'nonCompliant' && localStorage.getItem(MFA_COMPLIANCE_SETUP_PENDING) !== null

  useEffect(() => {
    if (status === 'compliant') {
      localStorage.removeItem(MFA_COMPLIANCE_SETUP_PENDING)
    }
  }, [status])

  useEffect(() => {
    if (shouldShow) dispatch(setupMFAForLogin())
  }, [shouldShow, dispatch])

  return shouldShow
}
